<template>
  <Popper placement="top" class="light" v-bind="$attrs">
    <slot name="icon">
      <svg :style="{ width: width + 'px', height: height + 'px'}">
        <use :xlink:href="`#${icon}`"></use>
      </svg>
    </slot>
    <template #content>
      <div v-if="hasPopperSlot" class="p-3">
        <slot name="popper"></slot>
      </div>
      <div :class="`hoverBox`" v-else :style="{ maxWidth: boxWidth + 'px', maxHeight: boxHeight + 'px', overflow: 'auto'}">
        <span v-if="title" v-html=title></span>
        <span v-if="description" v-html=description></span>
      </div>
    </template>
  </Popper>
</template>

<script>
import Popper from 'vue3-popper';

export default {
  name: 'HoverIcon',
  components: {
    Popper,
  },
  props: {
    title: {
      type: String,
      default: null,
    },
    icon: {
      type: String,
      default: 'info-icon',
    },
    height: {
      type: Number,
      default: 20,
    },
    width: {
      type: Number,
      default: 20,
    },
    boxHeight: {
      type: Number,
      default: 400,
    },
    boxWidth: {
      type: Number,
      default: 800,
    },
    description: {
      type: String,
      default: null,
    }
  },
  computed: {
    hasPopperSlot() {
      return !!this.$slots.popper;
    },
  },
};
</script>

